const { render } = wp.element
import App from './App';
const { registerCoreBlocks } = wp.blockLibrary;

// Register blocks
import './blocks/giveaway-input';
import { registerAllowedCoreBlocks, getAllowedCoreBlocks, isBlockAllowed, getFilteredBlockTypes } from './blocks/register-core-blocks';

// Initialize core blocks registration
registerCoreBlocks();

const root = document.getElementById('giveasap-form-builder-root');

if (root) {
    render(<App />, root);
}
